class HistoryNode {
  constructor(snapshot, baseline) {
    this.snapshot = snapshot
    this.baseline = baseline
  }

  getState() {
    return this.snapshot
  }

  metrics() {
    const baselineMap = this._buildMap(this.baseline)
    const currentMap = this._buildMap(this.snapshot)

    let edited = 0
    let removed = 0
    let added = 0

    // Check for removed and edited items
    this.baseline.forEach(baselineItem => {
      const currentItem = currentMap.get(baselineItem.id)

      if (!currentItem) {
        removed++
      } else if (this._itemsDiffer(baselineItem, currentItem)) {
        edited++
      }
    })

    // Check for added items
    this.snapshot.forEach(currentItem => {
      if (!baselineMap.has(currentItem.id)) {
        added++
      }
    })

    return { edited, added, removed }
  }

  _buildMap(collection) {
    const map = new Map()
    collection.forEach(item => {
      map.set(item.id, item)
    })
    return map
  }

  _itemsDiffer(item1, item2) {
    const keys1 = Object.keys(item1)
    const keys2 = Object.keys(item2)
    const allKeys = new Set([...keys1, ...keys2])

    for (const key of allKeys) {
      if (key === "id") continue

      if (item1[key] !== item2[key]) {
        return true
      }
    }

    return false
  }
}

class CollectionChangeTracker {
  constructor(baseline) {
    this.baseline = this._deepCopy(baseline)
    this.history = [new HistoryNode(this._deepCopy(baseline), this.baseline)]
  }

  push(collection) {
    const newNode = new HistoryNode(this._deepCopy(collection), this.baseline)
    this.history.push(newNode)

    return this.getMetrics()
  }

  getMetrics() {
    return this.history[this.history.length - 1].metrics()
  }

  getCurrent() {
    return this._deepCopy(this.history[this.history.length - 1].getState())
  }

  _deepCopy(obj) {
    return JSON.parse(JSON.stringify(obj))
  }
}

export default CollectionChangeTracker
